// @flow

export const NEW_ENTITY_IDS = {
  collaborator: 'new-collaborator',
  invitee: 'new-invitee',
};
